import { notEmpty } from '@ezchops/helpers';
import { Note } from './Note';
import { XMLElementParser } from './XMLElementParser';
export class Measure extends XMLElementParser {
    constructor(node) {
        super(node);
    }
    get number() {
        return this.node.attributes?.number;
    }
    get elements() {
        const children = this.node.elements?.map(node => {
            switch (node.name) {
                case 'barline':
                    return new Barline(node);
                case 'attributes':
                    return new Attributes(node);
                case 'direction':
                    return new Direction(node);
                case 'note':
                    return new Note(node);
                case 'print':
                    return new Print(node);
                case 'backup':
                    return new Backup(node);
                case 'forward':
                    return new Forward(node);
                default:
                    throw new Error(`Unknown element: ${node.name}`);
            }
        }) ?? [];
        return children.filter(notEmpty);
    }
    get barlines() {
        return this.elements.filter(e => e instanceof Barline);
    }
    get notes() {
        return this.elements.filter(e => e instanceof Note);
    }
    get attributes() {
        return this.elements.filter(e => e instanceof Attributes);
    }
}
export class Print extends XMLElementParser {
    get isNewSystem() {
        return this.node.attributes?.['new-system'] === 'yes';
    }
}
export class Barline extends XMLElementParser {
    get location() {
        return this.node.attributes?.location;
    }
    get repeat() {
        return this.node.elements
            ?.find(e => e.name === 'repeat')
            ?.attributes?.direction;
    }
    get repeatStart() {
        return this.repeat === 'forward';
    }
    get repeatEnd() {
        return this.repeat === 'backward';
    }
}
export class Attributes extends XMLElementParser {
    get divisions() {
        return this.node.elements?.find(e => e.name === 'divisions')?.elements?.[0]?.text;
    }
    get signature() {
        const node = this.node.elements?.find(e => e.name === 'time');
        return node
            ? {
                numerator: node.elements?.find(e => e.name === 'beats')?.elements?.[0]?.text,
                denominator: node.elements?.find(e => e.name === 'beat-type')?.elements?.[0]?.text
            }
            : undefined;
    }
}
export class Direction extends XMLElementParser {
    get text() {
        return this.node.elements
            ?.find(e => e.name === 'direction-type')
            ?.elements
            ?.find(e => e.name === 'words')
            ?.elements?.[0]?.text;
    }
}
export class Backup extends XMLElementParser {
    get duration() {
        const duration = this.node.elements
            ?.find(e => e.name === 'duration')?.text;
        if (duration == null) {
            throw new Error('Duration is missing');
        }
        return duration;
    }
}
export class Forward extends XMLElementParser {
    get duration() {
        const duration = this.node.elements
            ?.find(e => e.name === 'duration')?.text;
        if (duration == null) {
            throw new Error('Duration is missing');
        }
        return duration;
    }
}
//# sourceMappingURL=Measure.js.map